<template>
    <div class="col-xl-5 col-md-6 box-col-12 xl-65">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-xl-9 product-main">
                        <div class="pro-slide-single">
                            <swiper :slidesPerView="1" :loop="true" :thumbs="{ swiper: thumbsSwiper }"
                                :autoplay="{ delay: 3500, disableOnInteraction: false, }" :spaceBetween="30"
                                :centeredSlides="true" :modules="modules" class="mySwiper">
                                <swiper-slide v-for="(product, index) in products.img" :key="index">
                                    <img :src="getImgUrl(product)" :id="index" class="img-fluid bg-img" alt="index" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>
                    <div class="col-xl-3 product-thumbnail">
                        <div class="pro-slide-right">
                            <swiper :breakpoints="swiperOptions.breakpoints" @swiper="setThumbsSwiper" :loop="true"
                                :autoHeight="true" :slidesPerView="3" :spaceBetween="3" :watchSlidesProgress="true"
                                :pagination="{
                                    clickable: true,
                                }" :modules="modules" class="Swiper">
                                <swiper-slide v-for="(product, index) in products.img" :key="index">
                                    <img :src="getImgUrl(product)" :id="index" class="img-fluid bg-img" alt="index"
                                        style="height:auto; " />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { FreeMode, Autoplay, Thumbs } from 'swiper';
import "swiper/css/thumbs"
import "swiper/css/free-mode";
import { mapState } from "vuex";
import router from '@/router';
export default {
    name: "productPage",
    data() {
        return {
            counter: 1,
            modalShow: false,
            activeTab: 'fabric',
            swiperOptions: {
                breakpoints: {

                    1215: {
                        direction: 'vertical'
                    }
                }
            },
        }
    },
    computed: {
        ...mapState({
            products: (state) =>
                state.product.products.find((item) => {
                    if (parseInt(router.currentRoute._rawValue.params.id) === item.id) return item;
                }),
        }),
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        const thumbsSwiper = ref(null);
        const setThumbsSwiper = (swiper) => {
            thumbsSwiper.value = swiper;
        };
        return {
            modules: [FreeMode, Autoplay, Thumbs], setThumbsSwiper, thumbsSwiper
        };
    },
    methods: {
        addToCart: function (product, qty) {
            product.quantity = qty ? qty : 1;
            this.$store.dispatch("product/addToCart", product);
        },
        getImgUrl(path) {
            return require('@/assets/images/' + path);
        },
    }
}
</script>